/*
 *
 * NexiClubWaiverPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-Jul-2025
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import NexiClubWaiverPopup from './NexiClubWaiverPopup'
import { doHidePopup } from 'Store/actions/popup'
import { doSaveConsent } from '../../routes/NexiClub/modules/NexiClubActions'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doHidePopup: () => dispatch(doHidePopup()),
  doSaveConsent: (payload) => dispatch(doSaveConsent(payload))
})

const mapStateToProps = (state) => ({
  localConsent: nullSafe(() => state.NexiClub.nexiClubLocalConsent, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(NexiClubWaiverPopup)
